import { format } from "date-fns"
import React from "react"
import { StreamingChatBubble } from "./streaming-chat-bubble"
import { type AssistantMessage } from "@/features/assistant/types/assistant.ts"

interface StreamingChatBubbleWrapperProps {
  message: AssistantMessage
  isStreaming?: boolean
  streamingContent?: string
  showTypingIndicator?: boolean
}

export const StreamingChatBubbleWrapper: React.FC<
  StreamingChatBubbleWrapperProps
> = ({
  message,
  isStreaming = false,
  streamingContent = "",
  showTypingIndicator = false,
}) => {
  const gpt_message = isStreaming ? streamingContent : message.gpt_response
  const user_message = message.user_message
  const timestamp = format(new Date(message.created_at), "HH:mm")

  return (
    <div className="flex flex-col space-y-2 py-2">
      <StreamingChatBubble
        timestamp={timestamp}
        isUser={true}
        message={user_message}
      />
      <StreamingChatBubble
        timestamp={timestamp}
        isUser={false}
        message={gpt_message}
        isStreaming={isStreaming}
        showTypingIndicator={showTypingIndicator}
      />
    </div>
  )
}
